import {connect} from 'react-redux';
import Reply, {ReplyProps} from './Reply';
import CommentModel from '../../types/CommentModel';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: ReplyContainerProps): Partial<ReplyProps> => {
   return {
      reply: ownProps.reply,
      isEditable: ownProps.isEditable,
      onSelect: ownProps.onSelect,
      selectedComment: state.selectedComment
   };
};

export default connect(mapStateToProps, null)(Reply);

interface ReplyContainerProps {
   reply: CommentModel;
   isEditable: boolean;
   onSelect(): void;
}
